import { useModuleBEM } from "@b2bportal/core-themes";
import { Page } from "@b2bportal/core-ui";
import { useI18nContext } from "@hopper-b2b/i18n";
import { ToggleGroup } from "@hsbc/portal";
import { PageHeader } from "@tenant/ui";
import { Cards, Credits } from "../../components";
import { WalletOptions, useWalletDisplay } from "./hooks/useWalletDisplay";
import styles from "./styles.module.scss";

const selectedPage = {
  [WalletOptions.Cards]: Cards,
  [WalletOptions.Credits]: Credits,
};

export const WalletPage = () => {
  const { t } = useI18nContext();
  const [block, cn] = useModuleBEM(styles, "Wallet");

  const {
    context: { selectedOption, options },
    handlers: { onOptionChange },
  } = useWalletDisplay();

  const Component = selectedPage[selectedOption];

  return (
    <Page header={<PageHeader hideSummary />}>
      <div className={block}>
        <div className={cn("header")}>
          <span className={cn("title")}>{t("wallet.title")}</span>
          <span className={cn("subtitle")}>{t("wallet.subtitle")}</span>
        </div>

        <div className={cn("container")}>
          <ToggleGroup options={options} onChange={onOptionChange} />

          <Component />
        </div>
      </div>
    </Page>
  );
};
